// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1N3_Q","location":"Header_location__35wNz"};